import { render, staticRenderFns } from "./MuralIntegration.vue?vue&type=template&id=0cf77f6f&scoped=true&"
import script from "./MuralIntegration.vue?vue&type=script&lang=js&"
export * from "./MuralIntegration.vue?vue&type=script&lang=js&"
import style0 from "./MuralIntegration.vue?vue&type=style&index=0&id=0cf77f6f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf77f6f",
  null
  
)

export default component.exports